import styled from 'styled-components';
import {
  Alert,
  CodeEditor,
  FlexColumn,
} from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { YamlValidationError } from './types';

const EditorColumn = styled(FlexColumn)`
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
  max-width: 960px;
  margin-inline: auto;
  padding-right: ${({ theme }) => theme.spacing(4)};
  padding-bottom: ${({ theme }) => theme.spacing(3)};
`;

type Props = {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  grayedOut?: boolean;
  errors: YamlValidationError[];
  editorKey?: string;
};

const ErrorsContainer = ({ errors }: { errors: string[] }) => (
  <Alert severity="error">
    {errors.map((error, index) => (
      <Typography key={index}>{error}</Typography>
    ))}
  </Alert>
);

const YamlCodeEditor = ({
  value,
  onChange,
  readOnly,
  grayedOut,
  errors,
  editorKey,
}: Props) => (
  <EditorColumn>
    <CodeEditor
      key={editorKey}
      readOnly={readOnly}
      grayedOut={grayedOut}
      mode="yaml"
      markers={errors.map((error) => ({
        startRow: error.line,
        startCol: -1,
        endRow: error.line,
        endCol: 10000,
        className: 'error-marker',
        type: 'text',
      }))}
      annotations={errors.map((error) => ({
        row: error.line,
        text: error.message,
        type: 'error',
      }))}
      value={value}
      onChange={onChange}
    />
    {errors.length > 0 && (
      <ErrorsContainer errors={errors.map((error) => error.message)} />
    )}
  </EditorColumn>
);

export default YamlCodeEditor;
